/* assets/rolex-tracking.js
 * --------------------------------------------------------------------------
 * Gestisce gli eventi di interazione Rolex Bespoke via _satellite.track().
 * Le regole in Adobe Launch sono gia' configurate lato Rolex: qui dobbiamo
 * solo far scattare i track() corretti sui click delle CTA.
 *
 * USO 1 - CTA semplici: aggiungi data-rolex-track="<evento>" all'elemento.
 *   <a href="tel:..."           data-rolex-track="contactCall">Telefono</a>
 *   <a href="/pages/rolex-contact" data-rolex-track="findStore">Find a Store</a>
 *   <a href="https://maps..."   data-rolex-track="getDirections">Get Directions</a>
 *   <a href="https://wa.me/..." data-rolex-track="whatsappContact">WhatsApp</a>
 *   <a href="/brochure.pdf"     data-rolex-track="download">Download Brochure</a>
 *   (multi-POS: findStore su Model pages; getDirections su Contact + Store Contact)
 *
 * USO 2 - Form contatto andato a buon fine (dopo la submit OK):
 *   window.rolexTrack('contactForm');
 *
 * USO 3 - Appuntamenti (richiedono window.appointmentInformation):
 *   window.rolexTrackAppointment({
 *     purpose: 'collection discovery',   // in inglese
 *     date:    '2025-11-23',             // YYYY-MM-DD
 *     time:    '16:30',                  // HH:MM 24h
 *     event:   'bookAppointment'         // o 'modifyAppointment' / 'newAppointment'
 *   });
 *   // newAppointment non richiede appointmentInformation: window.rolexTrack('newAppointment');
 */
(function () {
  'use strict';

  // Invia un evento a Launch, mettendolo in coda finche' _satellite non e' pronto.
  function track(eventName) {
    if (!eventName) return;
    if (window._satellite && typeof window._satellite.track === 'function') {
      window._satellite.track(eventName);
    } else {
      (window.__rolexTrackQueue = window.__rolexTrackQueue || []).push(eventName);
    }
  }

  // Smaltisce la coda quando Launch e' caricato.
  function flushQueue() {
    if (!window._satellite || !window.__rolexTrackQueue) return;
    window.__rolexTrackQueue.forEach(function (e) { window._satellite.track(e); });
    window.__rolexTrackQueue = [];
  }
  document.addEventListener('DOMContentLoaded', flushQueue);
  window.addEventListener('load', flushQueue);

  // API pubblica per chiamate manuali (es. callback di una form).
  window.rolexTrack = track;

  // Helper appuntamenti: costruisce la stringa "purpose|dayOfWeek|YYYY-MM-DD|HH:MM".
  window.rolexTrackAppointment = function (opts) {
    opts = opts || {};
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var dow = '';
    if (opts.date) {
      var d = new Date(opts.date + 'T00:00:00');
      if (!isNaN(d.getTime())) dow = days[d.getDay()];
    }
    window.appointmentInformation = [
      opts.purpose || '',
      dow,
      opts.date || '',
      opts.time || ''
    ].join('|');
    track(opts.event || 'bookAppointment');
  };

  // Event delegation: intercetta tutte le CTA con data-rolex-track.
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-rolex-track]') : null;
    if (!el) return;
    track(el.getAttribute('data-rolex-track'));
  }, true);
})();
